module.exports = __webpack_public_path__ + "img/logo.633a2cf3.svg";